import { BitkitButton, BitkitEmptyState, BitkitLink, IconTasks } from '@bitrise/bitkit-v2';
import { Text } from '@chakra-ui/react/text';

type TestAddonNotAvailableEmptyStateProps = {
  planSelectorUrl: string;
  artifactsTabUrl?: string;
};

export const TestAddonNotAvailableEmptyState = ({
  artifactsTabUrl,
  planSelectorUrl,
}: TestAddonNotAvailableEmptyStateProps) => (
  <BitkitEmptyState
    icon={IconTasks}
    headingText="Your test details would appear here"
    bodyText={
      <Text as="span" display="block">
        Test Reports add-on is not available in your current plan.
        {artifactsTabUrl && (
          <>
            {' '}
            You can view your uploaded test results under{' '}
            <BitkitLink href={artifactsTabUrl} colorVariant="purple">
              Artifacts
            </BitkitLink>
            .
          </>
        )}{' '}
        To access a more detailed analysis, upgrade your plan.
      </Text>
    }
  >
    <BitkitButton href={planSelectorUrl} isExternal variant="primary" size="md">
      View plans
    </BitkitButton>
  </BitkitEmptyState>
);
